import React from 'react';
import './faq.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import FAQ from '../pricing-FAQ/pricing-faq';
import { Link } from 'react-router-dom';
const Navbarfaq = () => {
  const handleKnowMoreClick = () => {
    if (!sessionStorage.getItem("initialScrollPosition")) {
      sessionStorage.setItem("initialScrollPosition", window.scrollY);
    }
    sessionStorage.setItem("scrollPosition", window.scrollY);
    window.location.href = "/contact-us";
  };
  return (
    <div className='faq-overall'>
      <div className="faq-top-container ">
        <div className='resources-faq-breadcrumb'>
          <div className="faq-breadcrumb">
            <span style={{ color: '#FFFFFF', fontWeight: '600', textDecoration: 'none', marginRight: '50px' }}>
              <Link
                to={-1}
                style={{ color: '#FFFFFF', textDecoration: 'none' }}
                state={{ scrollPosition: location.state?.scrollPosition }}
              >
                Back
              </Link>
              <span style={{ marginLeft: '10px' }}> /</span>
              <span style={{ marginLeft: '10px' }}> FAQ</span>
            </span>
          </div>
        </div>
        <h6 className="faq-content-wrapper">Frequently Asked Questions</h6>
        {/* <div className="faq-search-wrapper d-flex justify-content-center">
          <div className="faq-search-container d-flex align-items-center">
            <FontAwesomeIcon icon={faSearch} className="faq-search-icon" />
            <input type="text" placeholder="Search Your Queries" className="faq-search-input " />
            <button type="submit" className="faq-search-button">
              Search
            </button>
          </div>
        </div> */}
      </div>
      <FAQ fromNavbar={true} />
      <div className="contact-help-wrapper d-flex justify-content-center">
        <div className="contact-help-container d-flex flex-column align-items-center">
          <h2 className="contact-help-head">Need more help?</h2>
          <p className="contact-help-content">
            Feel free to reach out—we're here to answer your questions and guide you every step of the way!           </p>
          <br />
          <button className="contact-help-button" onClick={handleKnowMoreClick}>Contact Us</button>
        </div>
      </div>
    </div>
  );
};

export default Navbarfaq;